// extracted by mini-css-extract-plugin
export default {"export":"styles_export__PqnYS","generalExport":"styles_generalExport__Xn5Ja","lessHeight":"styles_lessHeight__Jwq3L"};